import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { AuthService } from '@app/components/authentication/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    const signinChecked = await this.checkLogin(state.url);
    return (signinChecked) ? signinChecked : this.router.parseUrl(this.authService.redirectUrl);
  }

  /**
   * @description Check authentication status
   * @private
   * @param {string} url
   * @return {*}  {(Promise<boolean | UrlTree>)}
   */
  private async checkLogin(url: string): Promise<boolean | UrlTree> {
    const isSignedIn = await this.authService.isSignedIn();
    const isAuthPage = url.includes('/auth/');

    if (isSignedIn != isAuthPage) {
      // Carry on
      return true;
    } else if (isAuthPage) {
      // If signed in and on the sign in page, redirect
      return this.router.parseUrl(this.authService.redirectUrl);
    } else {
      // Not signed in, go to sign in page
      return this.router.parseUrl('/initial');
    }
  }
}
